import { combineReducers } from 'redux';
import findIndex from 'lodash.findindex';
import find from 'lodash.find';
import {
  LANGUAGE_SELECTOR_SELECT,
  LANGUAGE_SELECTOR_MOVE_UP,
  LANGUAGE_SELECTOR_MOVE_DOWN,
  LANGUAGE_SELECTOR_REMOVE,
  LANGUAGE_SELECTOR_SAVE,
  LANGUAGE_SELECTOR_ENABLE_FLAG,
} from '../actions/action-names';

const selectedLanguage = (state = 'EN', action) => {
  switch(action.type) {
    case LANGUAGE_SELECTOR_SELECT:
      return action.lang;

    case LANGUAGE_SELECTOR_SAVE:
      if (action.langs && action.langs.length === 0) {
        return action.langInfo.name;
      }

      return state;

    case LANGUAGE_SELECTOR_REMOVE:
      if (state !== action.lang) {
        return state;
      }

      const nextLang = find(action.langs, l => l.name !== action.lang);

      if (nextLang) {
        return nextLang.name;
      }

      return state;

    default:
      return state;
  }
};

const enableFlag = (state = false, action) => {
  switch(action.type) {
    case LANGUAGE_SELECTOR_ENABLE_FLAG:
      return action.enableFlag;

    default:
      return state;
  }
};

const langs = (state = [], action) => {
  const slIndex = findIndex(state, l => l.name === action.selectedLanguage);

  switch(action.type) {
    case LANGUAGE_SELECTOR_REMOVE:
      return state.filter(l => l.name !== action.lang);

    case LANGUAGE_SELECTOR_MOVE_UP:
      return state.length === 0 || slIndex === 0 ? state : [
        ...state.slice(0, slIndex - 1),
        state[slIndex],
        state[slIndex - 1],
        ...state.slice(slIndex + 1)
      ];

    case LANGUAGE_SELECTOR_MOVE_DOWN:
      return state.length === 0 || slIndex === state.length - 1 ? state : [
        ...state.slice(0, slIndex),
        state[slIndex + 1],
        state[slIndex],
        ...state.slice(slIndex + 2)
      ];

    case LANGUAGE_SELECTOR_SAVE:
      const currentLanguage = find(state, l => l.name === action.langInfo.name);
      const lang = {
        name: action.langInfo.name,
        title: action.langInfo.title,
        url: action.langInfo.url
      };

      if (currentLanguage) {
        return state.map(l => l === currentLanguage ? lang : l);
      }

      return [
        ...state,
        lang
      ];

    default:
      return state;
  }
};

export default combineReducers({
  selectedLanguage,
  enableFlag,
  langs,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/language-element-options-reducers.js